import { Api } from './Api'

class BankID {
  /**
   *
   * @param {string} ocr
   * @param {number} customerId
   * @param {string} method
   * @param {string} endUserIp
   * @param {string|null} userVisibleData
   * @param {string|null} orderRef
   * @param {AbortSingal|null} signal
   * @returns Promise
   */
  post (
    ocr,
    customerId,
    method,
    endUserIp,
    userVisibleData = null,
    orderRef = null,
    signal = null
  ) {
    const body = {
      customer_id: customerId,
      method,
      end_user_ip: endUserIp,
      order_ref: orderRef,
      user_visible_data: userVisibleData,
      mobile_only: true,
      use_pin_code: true
    }

    if (method === 'collect') {
      body.translate_hint_code = false
    }

    if (['sign', 'auth'].includes(method)) {
      body.filter_secret_token = true
    }

    return fetch(`${Api.getBaseUrl()}bankidstandard/${ocr}`, Api.getOptions('POST', body, signal))
  }

  /**
   *
   * @param {number} customerId
   * @param {string} orderRef
   * @param {AbortSignal|null} signal
   * @returns Promise
   */
  cancel (
    customerId,
    orderRef,
    signal = null
  ) {
    const body = {
      method: 'cancel',
      customer_id: customerId,
      order_ref: orderRef
    }

    return fetch(`${Api.getBaseUrl()}bankidstandard`, Api.getOptions('POST', body, signal))
  }

  /**
   *
   * @param {number} customerId
   * @param {string} orderRef
   * @returns Promise
   */
  qrCode (
    customerId,
    orderRef,
    signal = null
  ) {
    const body = {
      customer_id: customerId,
      order_ref: orderRef
    }

    return fetch(`${Api.getBaseUrl()}bankidqrcode`, Api.getOptions('POST', body, signal))
  }
}

export default BankID
